__turbopack_context__.v({
  "shippingCalloutBanner--additionalMargin": "_jADMa_shippingCalloutBanner--additionalMargin",
});
